/**
 * Development-only logging utility
 * Logs are only shown in development mode to keep production console clean
 */

const isDevelopment = process.env.NODE_ENV === 'development';

const logger = {
  /**
   * Debug-level logging (only in development)
   */
  debug: (...args) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },

  /**
   * Info-level logging (only in development)
   */
  info: (...args) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },

  /**
   * Warning-level logging (shown in all environments)
   */
  warn: (...args) => {
    console.warn(...args);
  },

  /**
   * Error-level logging (shown in all environments)
   */
  error: (...args) => {
    console.error(...args);
  },

  /**
   * Group logging (only in development)
   */
  group: (label) => {
    if (isDevelopment && console.group) {
      console.group(label);
    }
  },

  groupEnd: () => {
    if (isDevelopment && console.groupEnd) {
      console.groupEnd();
    }
  },
};

export default logger;
